module.exports = __webpack_public_path__ + "static/media/noPhotoProvided.00e2b25b.png";